import { sendDataLayerEvent } from './analytics';

export const getScrollDepthDataLayerInfo = (params) => {
  const label = params[2];
  const feedModuleMatch = label.match(/Reached Homepage Module - (.*) - feed/);
  if (feedModuleMatch) {
    return {
      eventName: 'View',
      data: {
        pageModule: 'Feed',
        moduleTitle: feedModuleMatch[1]
      }
    };
  }

  const contentModuleMatch = label.match(/Reached Homepage Module - (.*) - content/);
  if (contentModuleMatch) {
    return {
      eventName: 'View',
      data: {
        pageModule: 'Content',
        moduleTitle: contentModuleMatch[1]
      }
    };
  }

  switch (label) {
    case 'Reached Homepage Module - Homepage - hero':
      return {
        eventName: 'View',
        data: {
          pageModule: 'Hero stories'
        }
      };
    case 'Reached Homepage Module - Today on R29 - hero':
      return {
        eventName: 'View',
        data: {
          pageModule: 'Hero stories'
        }
      };
    case 'Reached Featured Stories':
      return {
        eventName: 'View',
        data: {
          pageModule: 'Featured stories'
        }
      };
    case 'Reached Featured Story':
      return {
        eventName: 'View',
        data: {
          pageModule: 'Featured story'
        }
      };
    case 'Related Stories Module':
      return {
        eventName: 'View',
        data: {
          'pageModule': 'Related Stories (In-line)'
        }
      };
    case 'Most Talked About':
      return {
        eventName: 'View',
        data: {
          'pageModule': 'Most Talked About'
        }
      };
    case 'Trending Videos':
      return {
        eventName: 'View',
        data: {
          'pageModule': 'Trending Videos'
        }
      };
    case 'Related Content':
      return {
        eventName: 'View',
        data: {
          'pageModule': 'Related Content (Feed)'
        }
      };
    case 'Reached Shopping':
      return {
        eventName: 'View',
        data: {
          pageModule: 'Shopping'
        }
      };
    case 'Reached Series module':
      return {
        eventName: 'View',
        data: {
          pageModule: 'Original Series'
        }
      };
    case 'Reached More Stories':
      return {
        eventName: 'View',
        data: {
          pageModule: 'More Stories'
        }
      };
    case 'Reached About':
      return {
        eventName: 'View',
        data: {
          pageModule: 'About'
        }
      };
    case 'Reached Most Popular':
      return {
        eventName: 'View',
        data: {
          pageModule: 'Most Popular'
        }
      };
    case 'Reached Super Sale':
      return {
        eventName: 'View',
        data: {
          pageModule: 'Super Sale'
        }
      };
    case 'Reached bottom of page':
      return {
        eventName: 'View',
        data: {
          pageModule: 'Bottom of Page'
        }
      };
    case 'Initial Scroll':
      return {
        eventName: 'Scroll - 0',
        data: {
          scrollDepthPercentage: 0
        }
      };
    case '25%':
      return {
        eventName: 'Scroll - 25',
        data: {
          scrollDepthPercentage: 25
        }
      };
    case '50%':
      return {
        eventName: 'Scroll - 50',
        data: {
          scrollDepthPercentage: 50
        }
      };
    case '75%':
      return {
        eventName: 'Scroll - 75',
        data: {
          scrollDepthPercentage: 75
        }
      };
    case '100%':
      return {
        eventName: 'Scroll - 100',
        data: {
          scrollDepthPercentage: 100
        }
      };
    default:
      return false;
  }
};

export const dataLayerPushSendScrollDepthEvent = (params) => {
  const eventData = getScrollDepthDataLayerInfo(params);
  if (eventData) {
    sendDataLayerEvent(eventData.eventName, eventData.data);
  }
};
